import { render } from "./DataTablePolizas.vue?vue&type=template&id=0824add8&scoped=true"
import script from "./DataTablePolizas.vue?vue&type=script&lang=js"
export * from "./DataTablePolizas.vue?vue&type=script&lang=js"

import "./DataTablePolizas.vue?vue&type=style&index=0&id=0824add8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0824add8"]])

export default __exports__